import React from 'react';
import { styled } from '@this/constants/themes';
import type SegmentClass from '@this/src/domain/transit/segment';
import type SelectStore from '@this/src/domain/select_store';
import type Transit from '@this/src/domain/transit/transit';
import SelectTransportBoxRightInListTemplate from '../../right/right_in_list.template';
import PackageRouteInfo from './PackageRouteInfo';

interface PackageListProps {
  transport: Transit;
  selected: boolean;
  loading: boolean;
  handleChange: () => void;
  store: SelectStore;
  segment: SegmentClass;
  segmentIdx: number;
}

const PackageList: React.FC<PackageListProps> = ({
  transport,
  selected,
  loading,
  handleChange,
  store,
  segment,
  segmentIdx
}) => {
  const isAirPackage = store.result.type === 'airPackage';
  const hasAir = transport.airExists();

  return (
    <div className="select-transport-box__button_exist_leg_shortdistance">
      <StyledLeft>
        {segment.legs.map((leg, i) => (
          <StyledSegment key={`plane_leg_short_distance_${i}`}>
            <PackageRouteInfo leg={leg} legIndex={i} segment={segment} segmentIdx={segmentIdx} hasAir={hasAir} />
          </StyledSegment>
        ))}
      </StyledLeft>
      <div className="select-transport-box__right-wrapper-shortdistance">
        {/* MEMO: この関数で使用されているコンポーネントは 旧版(short distanceではないもの)のコンポーネントを使用している。
            short distance用のコンポーネントを新規定義することを推奨。 */}
        <SelectTransportBoxRightInListTemplate
          loading={loading}
          selected={selected}
          hovered={transport.hovered}
          price={undefined} // 旧 price={isWbfPackage ? transport.additionalPrice || 0 : undefined}
          isAdditional={false} // 旧 isAdditional={isWbfPackage}
          priceRange={isAirPackage ? transport.price_range : undefined}
          showsPricePerPersonText={!isAirPackage}
          onClick={handleChange}
          onTouchStart={transport.handleTouched}
          onMouseOver={transport.setHovered(true)}
          onMouseLeave={transport.setHovered(false)}
          isPackage
        />
      </div>
    </div>
  );
};

const StyledLeft = styled.div`
  flex-shrink: 10;
  width: 100%;
`;

const StyledSegment = styled.div`
  margin: 0;
  display: flex;
  align-items: center;
  &:first-child {
    padding-top: 5px;
  }
  &:last-child {
    padding-bottom: 5px;
  }
`;

export default PackageList;
